import "./search.scss";
import { getValue } from "@utils/lodash";
import SearchSubheaderSvgComponent from "../../../../src/assets/svg-components/sub-header/search";

export default function Search(props: any) {
  return (
    <section className="common-search-wrapper__filter d-flex align-items-center">
      {props.showSearchTextbox && (
        <>
          &nbsp;&nbsp;&nbsp;
          <div className="common-search-wrapper__filter-form-group form-group m-0">
            <input
              type="text"
              autoComplete="off"
              placeholder={
                getValue(props, `searchPlaceholder`, "")
                  ? getValue(props, `searchPlaceholder`, "")
                  : "Search"
              }
              className="common-search-wrapper__filter-search-input"
              value={getValue(props, `searchInput`, "")}
              onChange={props.handleChangeSearch}
            />
            <img
              src="/images/search.svg"
              className="img-fluid common-search-wrapper__filter-input-image"
            />

            <img
              src="/images/close-black.svg"
              className="img-fluid common-search-wrapper__filter-image-close"
              onClick={() => {
                props.toggleSearchClose();
              }}
            />
          </div>
        </>
      )}

      <div
        className="common-search-wrapper__filter-container cursor-pointer icon-content-holder"
        onClick={() => {
          props.toggleSearchClose();
        }}
      >
        <div className="d-flex">
          <img
            src="/images/search-grey.svg"
            className="img-fluid common-search-wrapper__filter-image"
          />
        </div>
        <h6 className="common-search-wrapper__filter-title">
          {props.searchText || "SEARCH"}
        </h6>
      </div>
      {props.calender && (
        <div
          className="common-search-wrapper__filter-container cursor-pointer icon-content-holder icon-content-calendar-view"
          onClick={() => {
            if (getValue(props, `compliance_task_ids.length`, 0) > 0) {
              props.removeCalenderList();
            }
            props.handleNavigateCalenderView();
          }}
        >
          <div className="d-flex">
            <img
              src="/images/calendar_view.svg"
              className="img-fluid common-search-wrapper__filter-image"
            />
          </div>
          <h6
            className="common-search-wrapper__filter-title"
            style={{ color: "#1A73E8", fontSize: "10px" }}
          >
            {"CALENDAR VIEW"}
          </h6>
        </div>
      )}
    </section>

    // <>
    // <div className="floatable-search-container">
    // 	<form action="/search" method="get">
    // 	{/* <input className="search expandright" id="searchright" type="search" name="q" placeholder="Search" /> */}
    // 	<input
    // 					type="text"
    // 					autoComplete="off"
    // 					placeholder={getValue(props,`searchPlaceholder`,'')?getValue(props,`searchPlaceholder`,''):"Search"}
    // 					className="search expandright"
    // 					value={getValue(props, `searchInput`, "")}
    // 					onChange={props.handleChangeSearch}
    // 					id="searchright"
    // 				/>
    // 	<label className="searchbutton" htmlFor="searchright" data-tip data-for='subHeaderSearch'>
    // 		<SearchSubheaderSvgComponent />
    // 	</label>
    // 	</form>
    // </div>
    // </>
  );
}
